module.exports = __webpack_public_path__ + "static/img/huaweiNova7.525e17c1.png";